export const emptyObject = {};
export const emptyArray = [];
export const emptyString = '';